import React from 'react'
import { Cell } from 'rsuite-table'
import './ConfidenceScoreCell.scss'

type ConfidenceScoreCellProps = {
  rowData?: { [key: string]: any },
  dataKey: string
}

const ConfidenceScoreCell: React.FC<ConfidenceScoreCellProps> = ({
  rowData,
  dataKey,
  ...props
}) => {
  const score = rowData?.[dataKey] as number | undefined
  return (
    <Cell style={{ paddingLeft: '15%' }} {...props}>
      <span className="confidence-score-badge">{score ?? 0}</span>
    </Cell>
  )
}

export default ConfidenceScoreCell
